<label
  *ngFor="let predefinedPolicy of predefinedPolicies"
  [ngClass]="{
    'w-checkbox': !isPhysicalDevice,
    'checkbox-field': !isPhysicalDevice,
    'ion-no-padding': isPhysicalDevice
  }"
>
  <ng-container *ngIf="isPhysicalDevice">
    <ion-item class="ion-no-padding" lines="none" (click)="toggle(predefinedPolicy)">
      <ion-label>{{ predefinedPolicy }}</ion-label>
      <ion-checkbox slot="start" mode="md" value="{{ predefinedPolicy }}" [checked]="checked(predefinedPolicy)" [attr.aria-label]="predefinedPolicy">
      </ion-checkbox>
    </ion-item>
  </ng-container>
  <ng-container *ngIf="!isPhysicalDevice">
    <div
      class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"
      [ngClass]="{ 'w--redirected-checked': checked(predefinedPolicy) }"
    ></div>
    <input
      type="checkbox"
      value="{{ predefinedPolicy }}"
      (change)="toggle(predefinedPolicy)"
      [checked]="checked(predefinedPolicy)"
      style="opacity: 0; position: absolute; z-index: -1"
    />
    <span class="checkbox-label w-form-label"> {{ predefinedPolicy }} </span>
  </ng-container>
</label>

<div [ngClass]="{ 'site-rule-wrapper': hideMobile }">
  <h4>Did we miss anything? Continue adding more rules to your property below...</h4>
  <ng-container *ngFor="let policy of customPolicies?.controls; let i = index">
    <div *ngIf="policy?.value?.custom">
      <div class="_6-px-spacer"></div>
      <textarea
        [formControl]="policy.controls.description"
        id="policy-{{ i }}"
        class="textarea w-input semi-rounded"
        (change)="descriptionChanged(policy)"
        placeholder="Click here and start typing to add a new rule or information that your guest needs while staying at the site"
      ></textarea>
    </div>
  </ng-container>
</div>
<div *ngIf="hideMobile" class="add-rules-wrapper">
  <div class="_12-px-spacer"></div>
  <div class="horz-line"></div>
  <div class="_6-px-spacer"></div>
  <h3 class="heading-3">
    Add your own rules and policies to your property by editing your property, to add go to the &ldquo;Rules &amp;
    Policies&rdquo; section.
  </h3>
</div>
